import { Component } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidatorFn,
} from '@angular/forms';
import { WholesalerPharmacyService } from '../../services';
import { ICON_TYPE } from '@spartacus/storefront';

@Component({
  selector: 'app-pharmacy-search',
  templateUrl: './pharmacy-search.component.html',
})
export class PharmacySearchComponent {
  constructor(protected wholesalerPharmacyService: WholesalerPharmacyService) {}
  iconTypes = ICON_TYPE;
  formGroup: FormGroup = new FormGroup(
    {
      pharmacyName: new FormControl(''),
      city: new FormControl(''),
    },
    { validators: this.atLeastOneFieldValidator() }
  );

  submit() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      this.wholesalerPharmacyService.searchPharmacies({
        name: this.formGroup.get('pharmacyName')?.value,
        city: this.formGroup.get('city')?.value,
      });
    }
  }

  private atLeastOneFieldValidator(): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: boolean } | null => {
      const pharmacyName = formGroup.get('pharmacyName')?.value;
      const city = formGroup.get('city')?.value;
      if (!pharmacyName && !city) {
        return { atLeastOneRequired: true };
      }
      return null;
    };
  }
}
